/**
 * @generated SignedSource<<55ad1714ebb9ac98c949d0624c940e76>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type AgentBadge_agent$fragmentType = any;
export type JobEventActorType = "AGENT" | "DISPATCH" | "SYSTEM" | "USER" | "%future added value";
export type JobEventSignalReason = "AGENT_REFUSED" | "AGENT_STOP" | "CANCEL" | "PROCESS_RUN_ERROR" | "SIGNATURE_REJECTED" | "%future added value";
import type { FragmentType } from "relay-runtime";
declare export opaque type JobEventFinished_event$fragmentType: FragmentType;
export type JobEventFinished_event$data = {|
  +actor: {|
    +type: JobEventActorType,
  |},
  +exitStatus?: any,
  +job: {|
    +agent: ?{|
      +heartbeatAt: ?any,
      +$fragmentSpreads: AgentBadge_agent$fragmentType,
    |},
    +exitStatus: ?string,
    +softFailed: boolean,
  |},
  +signal?: ?string,
  +signalReason?: ?JobEventSignalReason,
  +timestamp: any,
  +$fragmentType: JobEventFinished_event$fragmentType,
|};
export type JobEventFinished_event$key = {
  +$data?: JobEventFinished_event$data,
  +$fragmentSpreads: JobEventFinished_event$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exitStatus",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventFinished_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "signal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "signalReason",
          "storageKey": null
        }
      ],
      "type": "JobEventFinished",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobEventActor",
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobTypeCommand",
      "kind": "LinkedField",
      "name": "job",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "softFailed",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Agent",
          "kind": "LinkedField",
          "name": "agent",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AgentBadge_agent"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "heartbeatAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "JobEvent",
  "abstractKey": "__isJobEvent"
};
})();

(node/*: any*/).hash = "aae364289967f591e7371492f1a048e5";

module.exports = ((node/*: any*/)/*: Fragment<
  JobEventFinished_event$fragmentType,
  JobEventFinished_event$data,
>*/);
